(function() {
    'use strict';
    angular.module('wbUtilities').directive('allocationChartPieAurea', ['$window', '$timeout', function($window, $timeout) {
    return {
        restrict: 'A',
        scope: {
            data: '=',
            options: '=?',
            scroller: '=?',
            highlight: '=?'
        },
        templateUrl: "/common/src/app/directives/allocation-chart-pie/allocation-chart-pie.tpl.html",
        link: function(scope, $el, attrs) {
            var updating = false;

            //for waypoints scroll classes
            if (!scope.scroller) {
                scope.scroller = false;
            }
            if (!scope.highlight) {
                scope.highlight = {};
            }
            if (!scope.options) {
                scope.options = {
                    showPercent: false,
                    useTargets: false
                };
            }

            //stores total amount of each type of holding
            //used for knowing the domain count for the colors
            scope.type_totals = {
                stock : 0,
                bond : 0,
                reits : 0,
                cash : 0
            };

            //colors for d3 to interpolate over position type range
            scope.type_colors = {
                "stock" : ["#255971", "#4ba9d6"], //blues
                "bond" : ["#412e4f", "#836a94"], //purples
                "reits" : ["#ff911d", "#fdebd8"], //oranges
                "cash" : ["#43BFB0", "#d9fde9"], //greens
                "none" : ["#222"] //null
            };

            var width = 500,
                height = 500,
                size = 95,
                grow = 20,
                growInnerAdj = 10,
                radius = Math.min(width, height) / 2;
            // var arc = d3.svg.arc().innerRadius(radius - size - grow).outerRadius(radius - grow - 20);
            // var arcGrow = d3.svg.arc().innerRadius(radius - size - (2*grow)).outerRadius(radius + grow - 20);
            var arc = d3.svg.arc().innerRadius(radius - size).outerRadius(radius);
            var arcGrow = d3.svg.arc().innerRadius(radius - size - grow + growInnerAdj).outerRadius(radius + grow);
            var hoverClass = "data-highlight";
            var pie = d3.layout.pie().sort(null).value(function (position) { return position[scope.percentKey] || 0; });
            var svg, svgPie, textSvg, textAllCashSvg, path, hover = {};

            var d3root = d3.select($el[0]);


            //highlight pie chart
            scope.highlight.on = function (key) {
                d3root.select(".pie-slice-" + key)
                   .transition()
                   .duration(500)
                   .attr("stroke-width", "0")
                   .attr("d", arcGrow);
            };
            scope.highlight.off = function (key) {
                d3root.select(".pie-slice-" + key)
                   .transition()
                   .duration(500)
                   .attr("stroke-width", "2px")
                   .attr("d", arc);
            };
            //highlight row when hovering over pie chart
            $el.find(".allocations-pie-div").on("mouseenter", "path", function() {
                //don't want to do the hover when it's transitioning
                if (updating) return;

                var key = angular.element(this).data("key");
                scope.highlight.on(key);
                angular.element(".data-" + key).addClass(hoverClass);

                if ("__data__" in this && "data" in this.__data__) {
                    var d = this.__data__;
                    var text;
                    var x = null, y = null;

                    if ( (d.data.category === "Cash" || d.data.ticker === "USD" || d.data.code === "USD")
                          && d.data[scope.percentKey] === 100) { return; }

                    textSvg.transition().duration(300).delay(0).attr("transform", "scale(0.005,0.005)");
                    hover.container.transition().duration(300).delay(0).attr("transform", "scale(1,1)");

                    if (d.data.category === "Cash") {
                        text = "USD";
                    } else {
                        text = d.data.ticker ? d.data.ticker : d.data.code;
                        if (text.length > 4) {
                            x = "0px";
                            y = "30px";
                        }
                    }

                    hover.label.selectAll("tspan").remove();
                    hover.label.append("tspan").text(getType(d.data));
                    if (text !== "NONE") {
                        hover.label.append("tspan").attr('x', x).attr('y', y).text(" (" + text + ")");
                    }
                    hover.percent.text(d.data[scope.percentKey].toFixed(1) + "%");
                }


            }).on("mouseleave", "path", function() {
                var key = angular.element(this).data("key");
                scope.highlight.off(key);
                angular.element(".data-" + key).removeClass(hoverClass);

                hover.container.transition().duration(300).delay(0).attr("transform", "scale(0.005, 0.005)");
                textSvg.transition().duration(300).delay(0).attr("transform", "scale(1,1)");

            });


            scope.createPie = function() {
                svg = d3root.select(".allocations-pie-div")
                    .append("svg")
                    .attr("style", "overflow: visible;")
                    .attr("class", "svg-content")
                    .attr('viewBox', '0 0 500 500');

                svgPie = svg.append("g")
                    .attr("class", "svg-pie")
                    .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")")
                    .append("g")
                    .attr("class", "svg-pie-rotate")
                ;

                textSvg = svg.append("g")
                    .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")")
                    .attr("class", "svg-pie-percents-box")
                    .append("g")
                    .attr("class", "svg-text-shift")
                    .append("g")
                ;


                textSvg.append("text")
                    .attr("class", "svg-pie-label svg-stocks-label")
                    .attr("dy", "-2.1em")
                    .attr("dx", "-2.5em")
                    .text(function () { return "Stocks"; });
                textSvg.append("text")
                    .attr("class", "svg-pie-stocks")
                    .attr("dy", "-0.3em")
                    .attr("dx", "-1.38em")
                    .text(function () { return "00%"; });


                textSvg.append("text")
                    .attr("class", "svg-pie-label svg-bonds-label")
                    .attr("dy", "-2.1em")
                    .attr("dx", "2.5em")
                    .text(function () { return "Bonds"; });
                textSvg.append("text")
                    .attr("dy", "-0.3em")
                    .attr("dx", "1.38em")
                    .attr("class", "svg-pie-bonds")
                    .text(function () { return "00%"; });


                textSvg.append("text")
                    .attr("class", "svg-pie-label svg-cash-label")
                    .attr("dy", "1.2em")
                    .text(function () { return "Cash"; });
                textSvg.append("text")
                    .attr("dy", "1.5em")
                    .attr("class", "svg-pie-cash")
                    .text(function () { return "00%"; });


                textAllCashSvg = svg.append("g")
                    .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")")
                    .attr("class", "svg-pie-all-cash-box");

                textAllCashSvg.append("circle")
                    .attr("fill", "#FFFFFF")
                    .attr("r", (radius - size - grow + growInnerAdj));

                textAllCashSvg.append("text")
                    .attr("class", "svg-pie-label")
                    .attr("dy", "-1.6em")
                    .text(function () { return "Cash"; });

                textAllCashSvg.append("text")
                    .attr("class", "svg-pie-all-cash")
                    .attr("dy", "0.3em")
                    .text(function () { return "100%"; });

                path = svgPie.selectAll("path");
            };
            scope.createPie();

            scope.updatePie = function(pieData) {
                //parent
                updating = true;

                var skipTransitions = false;

                //console.log(data);
                path = path.data(pieData, function(d) { return getKey(d.data); });

                if (path.empty()) {
                    skipTransitions = true;
                }

                var rotateEl = angular.element(svgPie.node());

                rotateEl.addClass('rotating');

                //transition removal
                path.exit()
                    .transition().duration(1000)
                    .attrTween("d", removeTween)
                    .remove();

                path.enter()[0].forEach(function (d) {
                    d.__data__.freshEnter=true;
                });
                addPathAttributes(path.enter().append("path"));
                //need to update the colors for all slices including existing
                addPathColors(path);
                //path.transition().duration(750).attrTween("d", transitionTween);

                //For future animating of additional items being added, see: http://bl.ocks.org/mbostock/5682158
                var transitionCount = 0;
                if (pieData.length && pieData[0].data.description === "Loading") {
                    path.transition().duration(1000)
                        .attrTween("d", initTween)
                        .each("start", function() { transitionCount++; })
                        .each("end", function() { if (!--transitionCount) { finishTransitions(); } });
                } else {
                    //can't figure out how to split transition for start() vs update, so determined in tween
                    path.transition().duration(function(d) {
                        if (skipTransitions) return 0;
                        return 1000;

                        /*
                        var avgEndTravelDistance = Math.abs(Math.abs(this._current.endAngle - d.endAngle) + Math.abs(this._current.startAngle - d.startAngle)) / 2;
                        var adjustedTime =
                            950 //base
                            + (1 - (avgEndTravelDistance / 2*Math.PI)) * 100 //distance adjustment
                            // + (20-d.data[scope.percentKey])*4 //percent adjustment
                        ;
                        var debug = null;
                        return adjustedTime;
                        */
                    })
                        .attrTween("d", transitionTween)
                        .each("start", function() { transitionCount++; })
                        .each("end", function(d) {
                            if (!--transitionCount) { finishTransitions(); }
                        });
                }

                function finishTransitions() {
                    updating = false;
                    rotateEl.removeClass('rotating');
                }

            };

            function initTween(d) {
                var start = {startAngle: 0, endAngle: 0};
                var interpolate = d3.interpolate(start, d);
                return function (t) {
                    return arc(interpolate(t));
                };
            }
            function removeTween(d) {
                var currentD = this._current;
                var avgAngle = (currentD.startAngle + currentD.endAngle) / 2;
                var end = {startAngle: avgAngle, endAngle: avgAngle};
                var interpolate = d3.interpolate(this._current, end);
                return function (t) {
                    return arc(interpolate(t));
                };
            }
            function transitionTween(d) {
                /*jshint validthis:true */
                var start, avgAngle;
                start = {startAngle: this._current.startAngle, endAngle: this._current.endAngle};
                if (d.freshEnter) {
                // if (start.startAngle == d.startAngle && start.endAngle == d.endAngle) {
                    //this is the case a slice is being added
                    avgAngle = (start.startAngle + start.endAngle) / 2;
                    start = {startAngle: avgAngle, endAngle: avgAngle};
                }

                var interpolate = d3.interpolate(start, d);
                this._current = interpolate(0);
                return function(t) {
                    return arc(interpolate(t));
                };
            }

            function addPathAttributes(path) {
                path.attr("class", function (d) {
                        return "slice pie-slice-" + getKey(d.data);
                    })
                    .attr("data-key", function (d) {
                        return getKey(d.data);
                    })
                    .attr("d", arc)
                    .each(function (d) { this._current = d; });
            }
            function addPathColors(path) {
                path.attr("fill", function(d) {
                        return getColor(d.data);
                    })
                    .attr("stroke", function(d) {
                        return getColor(d.data);
                    });
            }

            function addHoverTip() {
                hover.container = svg.append("g")
                    .attr("class", "svg-pie-tip")
                    .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")")
                    .append("g")
                    .attr("transform", "scale(0.005, 0.005)");
                hover.circle = hover.container
                    .append("circle")
                    .attr("fill", "transparent")
                    .attr("r", (radius - size - grow + growInnerAdj));
                hover.label = hover.container.append('text')
                    .attr("class", "fund-label")
                    .attr("transform", "translate(0, 40)")
                    .attr("fill", "#333333");
                hover.percent = hover.container.append('text')
                    .attr("class", "fund-percent")
                    .attr("transform", "translate(0, 0)")
                    .attr("fill", "#333333");
            }
            addHoverTip();


            /**
             * Returns next ordinal color for data type and cycles back to first color when max type count is reached
             * @var object getColor.type_count static count for cycling count
             * @param data
             */
            function getColor(data) {
                var colors, color,
                    type = getType(data);

                //so colors don't change when switching graph data
                if (getColor.color_index[getKey(data)]) {
                    return getColor.color_index[getKey(data)];
                }

                if (!getColor.type_count[type] || getColor.type_count[type] >= scope.type_totals[type]) {
                    getColor.type_count[type] = 1;
                } else {
                    getColor.type_count[type]++;
                }

                if (!(type in getColor.scale_function) || !getColor.scale_function[type][scope.type_totals[type]]) {
                    //store generator in getColor function prototype
                    /* jshint expr: true */
                    getColor.scale_function[type] || (getColor.scale_function[type] = {});
                    getColor.scale_function[type][scope.type_totals[type]] = d3.scale.linear()
                        .domain([1, scope.type_totals[type]])
                        .interpolate(d3.interpolateHcl)
                        .range([d3.rgb(scope.type_colors[type][0]), d3.rgb(scope.type_colors[type][1])]);
                }
                colors = getColor.scale_function[type][scope.type_totals[type]];
                color = colors(getColor.type_count[type]);
                //$ prefix to make it invisible to angular.equals methods
                data.$typeColor = color;
                getColor.color_index[getKey(data)] = color;
                return color;
            }
            getColor.color_index = {};
            getColor.type_count = {};
            getColor.scale_function = {};

            /**
             * Returns position type based on position name and/or description
             * @param position
             * @returns {*}
             */
            function getType(position) {
                var type, typeSwitch;
                if (position.category) {
                    typeSwitch = position.category;
                } else {
                    typeSwitch = position.name;
                }
                switch(typeSwitch) {
                    case "Stocks":
                    case "Stock":
                        type = "stock";
                        break;
                    case "Bonds":
                    case "Bond":
                        type = (position.description === "REITs" || position.code === "REIT") ? "reits" : "bond";
                        break;
                    case "Reits":
                        type = "reits";
                        break;
                    case "Cash":
                        type = "cash";
                        break;
                    case "None":
                        type = "none";
                }
                return type;
            }

            function getKey(data) {
                var key = "";
                if (data.code) {
                    key += data.code;
                }
                key += "-";
                if (data.ticker) {
                    key += data.ticker;
                }
                return key;
            }

            /**
             * Clears current get color incrementer and recalculates type totals
             * @param pieData
             */
            function updateCount(pieData) {
                getColor.type_count = {};
                scope.type_totals = {
                    stock : 0,
                    bond : 0,
                    reits : 0,
                    cash : 0,
                    none : 0
                };
                angular.forEach(pieData, function (piePosition) {
                    scope.type_totals[getType(piePosition.data)]++;
                });
            }

            function updateAngles(pieData) {

                if (scope.scroller) {
                    scope.scroller.angles.length = 0;
                    angular.forEach(pieData, function (piePosition) {
                        var angle;
                        angle = (piePosition.startAngle + (piePosition.endAngle - piePosition.startAngle) / 2) / (2 * Math.PI) * 360;
                        if (scope.scroller.invertGraph) {
                            angle += 180;
                        }
                        scope.scroller.angles.push(angle);
                    });
                    scope.scroller.selectedAngle = scope.scroller.angles[0];
                }

            }

            scope.$watch('data', function (data) {
                if (data) {
                    var pieData;
                    var stockPercent, bondPercent, cashPercent;
                    var dataSet;
                    
                    if (scope.options.useTargets) {
                        scope.percentKey = "target";
                    } else {
                        scope.percentKey = "percent";
                    }

                    if (typeof data.stocks === "object") {
                        stockPercent = data.stocks[scope.percentKey];
                        bondPercent = data.bonds[scope.percentKey];
                        cashPercent = data.cash[scope.percentKey];
                    } else {
                        stockPercent = data.stock_percent;
                        bondPercent = data.bond_percent;
                        //rounding to fix weird -0 javascript is stupid issue
                        // cashPercent = Math.round((100 - data.stock_percent - data.bond_percent)*100)/100;
                        // if (cashPercent < 0) cashPercent = 0;
                        cashPercent = 0;
                    }



                    dataSet = data.positions ? data.positions : data.asset_classes;

                    if (stockPercent || bondPercent || cashPercent) {
                        pieData = pie(dataSet);
                    } else {
                        pieData = pie([{
                            category: "None",
                            code: "NONE",
                            name: "Nothing",
                            percent: 0.0001,
                        }]);
                    }

                    updateAngles(pieData);
                    updateCount(pieData);
                    scope.updatePie(pieData);

                    if (!scope.options.showPercent && typeof data.total_value === "undefined") {
                        angular.element('.svg-pie-percents-box, .svg-pie-all-cash-box').css('visibility', 'hidden');
                    } else {
                        angular.element('.svg-pie-percents-box, .svg-pie-all-cash-box').css('visibility', '');

                        angular.element('.svg-pie-bonds').text(bondPercent.toFixed(0) + "%");
                        angular.element('.svg-pie-stocks').text(stockPercent.toFixed(0) + "%");
                        angular.element('.svg-pie-cash').text(cashPercent.toFixed(0) + "%");

                        if (cashPercent === 0) {
                            angular.element('.svg-text-shift').attr("transform", "translate(0,35)");
                            angular.element('.svg-pie-cash, .svg-cash-label').css('visibility', 'hidden');
                        } else {
                            angular.element('.svg-text-shift').attr("transform", "");
                            angular.element('.svg-pie-cash, .svg-cash-label').css('visibility', '');
                        }

                        // if (0 === (stockPercent + bondPercent) ) {
                        if (cashPercent === 100) {
                            //cover center with "CASH 100%"
                            angular.element('.svg-pie-all-cash-box').css('display', 'block');
                        } else {
                            angular.element('.svg-pie-all-cash-box').css('display', '');
                        }
                    }

                }
            }, true);
        }};
    }]);
})();
